$(() =>
{
    $(".services-tab-link")
        .on("click",
            function(e: Event)
            {
                e.preventDefault();
                $(this).tab("show");
                $(this).removeClass("active show");
            });
});